import { render, staticRenderFns } from "./agree-terms.vue?vue&type=template&id=ad7e9976&scoped=true&lang=pug"
import script from "./agree-terms.vue?vue&type=script&lang=js"
export * from "./agree-terms.vue?vue&type=script&lang=js"
import style0 from "./agree-terms.vue?vue&type=style&index=0&id=ad7e9976&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7e9976",
  null
  
)

export default component.exports